<div class="email-preview-container">
	<div *ngIf="loading" class="loading-message">Loading email...</div>

	<div *ngIf="error" class="error-message">
		<h2>Unable to load email</h2>
		<p>The requested email could not be found or has expired.</p>
	</div>

	<iframe *ngIf="!loading && !error"
		class="email-content"
		title="Email preview"
		sandbox="allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
		referrerpolicy="no-referrer"
		[attr.srcdoc]="emailHtml"></iframe>
</div>
